import React from 'react';
import ListGroup from 'react-bootstrap/ListGroup';

const Equipment = ({ classes, equipment }) => {
  const url = '/equipment/Select/' + equipment.equipment_id + '/' + equipment.brand.brand_name.replace(/ /g, '-') + '/' + equipment.name;
  return (
    <ListGroup.Item
      key={equipment.equipment_id}
      action
      href={url}
      className={classes.equipment}
    >
      {equipment.equipment_name}
    </ListGroup.Item>
  );
}

export default Equipment;
